import { Alert, AlertDescription } from '@/components/ui/alert';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { CheckCircleIcon, TriangleAlert } from 'lucide-react';
import { cn } from '@/utils/utils.ts';

interface StatusAlertProps {
  type: 'success' | 'error' | 'warning';
  message: string;
  className?: string;
}

const alertConfig = {
  error: { variant: 'destructive' as const, icon: ExclamationTriangleIcon, iconClass: '' },
  warning: { variant: 'warning' as const, icon: TriangleAlert, iconClass: 'text-[#663c00]' },
  success: { variant: 'default' as const, icon: CheckCircleIcon, iconClass: 'text-green-600' },
};

export function StatusAlert({ type, message, className }: StatusAlertProps) {
  if (!message) return null;

  const { variant, icon: Icon, iconClass } = alertConfig[type];

  return (
    <Alert
      variant={variant}
      className={cn(
        'flex items-center gap-4',
        type === 'success' && 'border-green-600',
        className
      )}
    >
      <div className="h-4 w-4">
        <Icon className={cn('h-4 w-4', iconClass)} />
      </div>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
